import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <!-- No tema escuro a escala de surface é invertida (styles.css): as variantes dark: mantêm o rodapé escuro -->
    <footer class="mt-12 bg-surface-900 px-4 py-6 text-center text-surface-0 dark:border-t dark:border-surface-200 dark:bg-surface-0 dark:text-surface-900">
      <p class="font-medium">© {{ year }} Prestige Salgados. Todos os direitos reservados.</p>
      <p class="mt-1 text-sm text-surface-400">Feito com 🥟 e tecnologia.</p>
    </footer>
  `
})
export class FooterComponent {
  year = new Date().getFullYear();
}
